import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Archive from '@/views/archive/archive.vue';
import Home from './views/home/home.vue';
import Blog from '@/views/blog/blog.vue';
import Privacy from '@/views/privacy/privacy.vue';
import Project from '@/views/project/project.vue';
import SignUp from '@/views/signUp/signUp.vue';
import Item from '@/views/item/item.vue';
import Crowdfunding from '@/views/crowdfunding/crowdfunding.vue';
import Single from '@/components/single/single.vue';
import Faq from '@/views/faq/faq.vue';
import Walk from '@/views/walk/walk.vue';
import WalkNL from '@/views/walknl/walk.vue';

import Summary from '@/views/summary/summary.vue';
import Letter from '@/views/letter/letter.vue';

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/project',
            name: 'project',
            component: Project,
        },
        {
            path: '/array-report',
            redirect: {
                name: 'project',
                hash: '#array-report',
            },
        },
        {
            path: '/project-group',
            redirect: {
                name: 'project',
                hash: '#project-group',
            },
        },
        {
            path: '/advisory-board',
            redirect: {
                name: 'project',
                hash: '#advisory-board',
            },
        },
        {
            path: '/donate',
            redirect: {
                name: 'crowdfunding',
                hash: '#donate',
            },
        },
        {
            path: '/fundraising',
            redirect: {
                name: 'crowdfunding',
                hash: '#crowdfunding',
            },
        },
        {
            path: '/thank-you',
            redirect: {
                name: 'crowdfunding',
                hash: '#thank-you',
            },
        },
        {
            path: '/results/:page(\\d+)?',
            name: 'results',
            component: Blog,
            meta: {
                child: 'result_item',
                title: 'Results',
                intro: 'results_intro',
                filter: true,
            },
        },
        {
            path: '/results/item/:uid',
            name: 'result_item',
            component: Item,
            meta: {
                type: 'result_item',
                parent: 'results',
            },
        },
        {
            path: '/news/:page(\\d+)?',
            name: 'news',
            component: Blog,
            meta: {
                child: 'news_item',
                title: 'News',
                intro: 'news_intro',
                filter: true,
            },
        },
        {
            path: '/news/item/:uid',
            name: 'news_item',
            component: Item,
            meta: {
                type: 'news_item',
                parent: 'news',
            },
        },
        {
            path: '/for-professionals/:page(\\d+)?',
            name: 'for_professionals',
            component: Blog,
            meta: {
                child: 'for_professionals_item',
                title: 'For professionals',
                intro: 'for_professionals_intro',
                filter: true,
            },
        },
        {
            path: '/for-professionals/item/:uid',
            name: 'for_professionals_item',
            component: Item,
            meta: {
                type: 'for_professionals_item',
                parent: 'for_professionals',
            },
        },
        {
            path: '/crowdfunding',
            name: 'crowdfunding',
            component: Crowdfunding,
            props: true,
        },
        {
            path: '/community/:page(\\d+)?',
            name: 'community',
            component: Blog,
            meta: {
                child: 'community_item',
                title: 'Community',
                intro: 'community_intro',
                filter: false,
            },
        },
        {
            path: '/community/item/:uid',
            name: 'community_item',
            component: Item,
            meta: {
                type: 'community_item',
                parent: 'community',
            },
        },
        {
            path: '/sign-up',
            name: 'sign_up',
            component: SignUp,
            props: {
                page: 'sign_up',
            },
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq,
        },
        {
            path: '/privacy-statement',
            name: 'privacy',
            component: Privacy,
        },
        {
            path: '/archive',
            name: 'archive',
            component: Archive,
        },
        {
            path: '/summary-questionnaire',
            name: 'summary',
            component: Summary,
        },
        {
            path: '/template-letter',
            name: 'letter',
            component: Letter,
        },
        {
            path: '/contact',
            name: 'contact',
            component: Single,
            props: {
                page: 'contact',
            },
        },
        {
            path: '/signed-up',
            name: 'signed_up',
            component: Single,
            props: {
                page: 'signed_up',
            },
        },
        {
            path: '/sign-up-error',
            name: 'signed-up_error',
            component: Single,
            props: {
                page: 'sing-up_error',
            },
        },
        {
            path: '/1200km',
            name: '1200km',
            redirect: {
                name: 'walk for chromosome6'
            }
        },
        {
            path: '/walkforchromosome6/nl',
            name: 'walk for chromosome6 nl',
            component: WalkNL,
        },
        {
            path: '/walkforchromosome6',
            name: 'walk for chromosome6',
            component: Walk,
        },
        {
            path: '*',
            component: Single,
            props: {
                page: 'not_found',
            },
        },
    ],
});
